/* eslint-disable no-tabs */

import MobileHeader from '@/components/MobileHeader';
import AppBottomNavigation from '@/containers/AppBottomNavigation';
import { style } from '@/styles/globals';
import { pr } from '@/utils/pxToRem';
import {
  Box, ListItem, Typography,
} from '@mui/material';
import { styled } from '@mui/system';
import Head from 'next/head';
import React from 'react';
import dynamic from 'next/dynamic';
import { useCheckIsMobile } from '@/utils/hooks/use-check-is-mobile';

const ContactPageDesktop = dynamic(() => import('./desktop'));

const StyledText = styled(Typography)`
  color: ${style.color.black2};
  margin-bottom: ${pr`8px`};
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
`;

const StyledListItem = styled(StyledText)`
  display: inline-block;
`;

const StyledTextHighLight = styled(StyledListItem)`
  color: ${style.color.product3};
  font-weight: bold;
`;

const Page = styled('div')`
  min-height: 100%;
  background: ${style.color.white2};
`;

const ContactPage = () => {
  const isMobile = useCheckIsMobile();
  if (!isMobile) {
    return <ContactPageDesktop />;
  }
  return (
    <>
      <Page>
        <Head>
          <title>Liên hệ với chúng tôi | Goyolo</title>
          <meta
            name="description"
            content="Goyolo.com là một nền tảng đặt vé máy bay, xe khách, tàu hoả,... nhanh chóng, tiện lợi với mức giá rẻ nhất"
          />
          <meta
            name="google-site-verification"
            content={process.env.NEXT_PUBLIC_GOOGLE_SITE_VERIFICATION}
          />
        </Head>
        <MobileHeader title="Liên hệ với chúng tôi" />
        <Box
          sx={{
            background: 'white',
            marginTop: '16px',
            padding: '16px',
          }}
        >
          <StyledText>Bạn đang gặp khó khăn ?</StyledText>
          <StyledText>Hãy liên lạc với chúng tôi qua 2 cách bên dưới:</StyledText>
          <ListItem
            sx={{
              display: 'list-item',
              paddingTop: '0px',
              paddingBottom: '0px',
            }}
          >
            <StyledListItem>Email: &nbsp;</StyledListItem>
            <StyledTextHighLight>lienhe.mb@vexere.com</StyledTextHighLight>
          </ListItem>
          <ListItem
            sx={{
              display: 'list-item',
              paddingTop: '0px',
              paddingBottom: '0px',
            }}
          >
            <StyledListItem>Hotline tổng đài: &nbsp;</StyledListItem>
            <StyledTextHighLight>19006484</StyledTextHighLight>
          </ListItem>
        </Box>
      </Page>
      <AppBottomNavigation />
    </>
  );
};

export default ContactPage;
